<template>
  <v-card
    class="mx-auto"
    width="100%"
  >
    <v-card-title>
      <v-app-bar
        flat
        class="white pa-0"
        dense
      >
        <v-toolbar-title data-cy="alerts_title">
          {{ $t("alert.title", "AML Compliance Alerts") }}
        </v-toolbar-title>
      </v-app-bar>
    </v-card-title>

    <v-container
      fluid
      class="pt-0"
    >
      <!-- Analytics KPI Cards -->
      <v-row class="mb-2">
        <v-col
          cols="12"
          sm="3"
          v-for="(stat, idx) in alertStats"
          :key="idx"
        >
          <v-card
            style="background: #f6faff"
            class="pa-3"
          >
            <div class="caption grey--text text--darken-1 font-weight-bold">
              {{ stat.status }}
            </div>
            <div class="text-h4 font-weight-bold black--text my-1">
              {{ stat.count || 0 }}
            </div>
            <div
              class="caption font-weight-medium"
              :style="{ color: stat.color }"
            >
              {{ stat.percentage || 0 }}% of total cases
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Filter Tabs -->
      <v-tabs
        v-model="activeTab"
        @change="fetchAlerts"
        class="mb-4"
      >
        <v-tab key="ALL">
          ALL
        </v-tab>
        <v-tab key="OPEN">
          OPEN
        </v-tab>
        <v-tab key="INVESTIGATING">
          INVESTIGATING
        </v-tab>
        <v-tab key="ESCALATED">
          ESCALATED
        </v-tab>
        <v-tab key="CLOSED_RESOLVED">
          RESOLVED
        </v-tab>
      </v-tabs>

      <!-- Alert Listing Data Table -->
      <v-data-table
        :headers="headers"
        :items="alerts"
        :loading="loading"
        class="elevation-1"
      >
        <template v-slot:item.status="{ item }">
          <v-chip
            :color="getStatusColor(item.status)"
            dark
            small
          >
            {{ item.status }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            icon
            small
            color="primary"
            @click="openAlertDetail(item)"
          >
            <v-icon>mdi-square-edit-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-container>

    <!-- Alert Detail & Status Patch Dialog -->
    <v-dialog
      v-model="dialog"
      width="600px"
    >
      <v-card v-if="activeAlert">
        <v-card-title class="headline grey lighten-2">
          Update Alert Context: {{ activeAlert.id }}
        </v-card-title>
        <v-card-text class="pt-4">
          <v-select
            v-model="patchForm.status"
            :items="[
              'OPEN',
              'INVESTIGATING',
              'ESCALATED',
              'CLOSED_RESOLVED',
              'CLOSED_FALSE_POSITIVE',
            ]"
            label="Workflow Status"
            outlined
            dense
          />
          <v-text-field
            v-model="patchForm.assignedTo"
            label="Assigned Investigator ID"
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            :loading="updating"
            @click="saveAlertStatus"
          >
            Save Status
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  name: 'AlertsPage',
  data () {
    return {
      loading: false,
      updating: false,
      dialog: false,
      activeTab: 0,
      statusKeys: [
        'ALL',
        'OPEN',
        'INVESTIGATING',
        'ESCALATED',
        'CLOSED_RESOLVED'
      ],
      alertStats: [
        { status: 'OPEN', count: 14, percentage: 40, color: '#D32F2F' },
        { status: 'INVESTIGATING', count: 8, percentage: 22, color: '#F57C00' },
        { status: 'ESCALATED', count: 5, percentage: 14, color: '#7B1FA2' },
        {
          status: 'CLOSED_RESOLVED',
          count: 8,
          percentage: 24,
          color: '#388E3C'
        }
      ],
      alerts: [],
      activeAlert: null,
      patchForm: { status: 'OPEN', assignedTo: '' },
      headers: [
        { text: 'Alert ID', value: 'id' },
        { text: 'Rule Code', value: 'ruleCode' },
        { text: 'Status', value: 'status' },
        { text: 'Assigned To', value: 'assignedTo' },
        { text: 'Created At', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  methods: {
    fetchStats () {
      this.$store.dispatch('alert/getAlertsDistribution')
    },
    fetchAlerts () {
      this.loading = true
      const status = this.statusKeys[this.activeTab]
      const params = status !== 'ALL' ? { status } : {}

      this.$store
        .dispatch('alert/getAlertsListing', params)
        .then((res) => {
          this.alerts = res.data || []
        })
        .finally(() => {
          this.loading = false
        })
    },
    openAlertDetail (alert) {
      this.activeAlert = alert
      this.patchForm.status = alert.status
      this.patchForm.assignedTo = alert.assignedTo || ''
      this.dialog = true
    },
    saveAlertStatus () {
      this.updating = true
      this.$store
        .dispatch('alert/updateAlertStatus', {
          id: this.activeAlert.id,
          payload: this.patchForm
        })
        .then(() => {
          this.dialog = false
          this.fetchAlerts()
          this.fetchStats()
        })
        .finally(() => {
          this.updating = false
        })
    },
    getStatusColor (status) {
      switch (status) {
        case 'OPEN':
          return 'red'
        case 'INVESTIGATING':
          return 'orange'
        case 'ESCALATED':
          return 'purple'
        case 'CLOSED_RESOLVED':
          return 'green'
        default:
          return 'grey'
      }
    }
  },
  mounted () {
    this.fetchStats()
    this.fetchAlerts()
  }
}
</script>
